module.exports = __webpack_public_path__ + "img/pimg13.79d4db79.png";